<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
       <div></div>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { attendanceCommentList, deleteAttendanceComment } from "@/api/api";
export default {
  name: "comment",
  mixins: [mixin_list(attendanceCommentList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        attendance:this.$route.query.id
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("attendanceComment.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("attendanceComment.username"),
          sortable: true,
          prop: "username",
        },
        {
          label: this.$t("attendanceComment.real_name"),
          sortable: true,
          prop: "real_name",
        },
        {
          label: this.$t("attendanceComment.phone_num"),
          sortable: true,
          prop: "phone_num",
        },
        {
          label: this.$t("attendanceComment.content"),
          sortable: true,
          prop: "content",
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 300,
          slot: "operation",
        },
      ]
    }
  },
  methods: {
    // async handleClick(type, data) {
    //   switch (type) {
    //     case "add":
    //       this.$router.push(`/readManagement/readList/readTaskList/edit?club=${this.$route.query.id}`)
    //       break;
    //     case "edit":
    //       this.$router.push(`/readManagement/readList/readTaskList/edit?id=${data.id}&club=${this.$route.query.id}`)
    //       break;
    //     case "toAttendanceList":
    //          this.$router.push(`/readManagement/readList/readTaskList/attendanceList?id=${data.id}`)
    //       break;
    //   }
    // },
    async del(id) {
      this.$confirm(this.$t('attendanceComment').sureDeleteComment, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteAttendanceComment(id)
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>

</style>